import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MAX_EVENT_DAYS, switchToCommunity } from './event-form';

/**
 * Shown under the end date when an Event runs longer than MAX_EVENT_DAYS.
 * Rather than only refusing, it offers the fix: keep the dates and save the
 * space as a community. Used by the claim wizard and the admin editor.
 */
@Component({
  selector: 'app-event-too-long-notice',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="too-long" *ngIf="form.get('endDate')?.errors?.['eventTooLong']" role="alert">
      <span>
        An event can run for at most {{ maxDays }} days. Something this long is a community.
      </span>
      <button type="button" (click)="makeCommunity()">Make it a community</button>
    </div>
  `,
  styles: [
    `
      .too-long {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
        margin-top: 8px;
        font-size: 13px;
        color: #b3261e;
      }
      .too-long button {
        font: inherit;
        font-weight: 600;
        padding: 6px 12px;
        border-radius: 8px;
        border: 1px solid currentColor;
        background: transparent;
        color: inherit;
        cursor: pointer;
      }
    `,
  ],
})
export class EventTooLongNoticeComponent {
  @Input({ required: true }) form!: FormGroup;
  readonly maxDays = MAX_EVENT_DAYS;

  makeCommunity(): void {
    switchToCommunity(this.form);
  }
}
